import { getImgUrl } from "@/utils/tools"

export default [
  {
    title: '营业执照',
    subTitle: '统一社会信用代码：91440300MA5EEE7T58',
    url: getImgUrl('publicMobile/license/yyzz.png'),
    showType: 2,
  },
  {
    title: '中华人民共和国增值电信业务经营许可证',
    subTitle: '经营许可证编号：粤B2-20190283',
    url: getImgUrl('publicMobile/license/zzdx.png'),
    showType: 2,
  },
  {
    title: '中华人民共和国增值电信业务经营许可证(附页)',
    subTitle: '经营许可证编号：粤B2-20190283',
    url: getImgUrl('publicMobile/license/zzdx-2.png'),
    showType: 2,
  },
  {
    title: '第二类医疗器械经营备案凭证',
    subTitle: '备案编号：粤深食药监械经营备 202020242号',
    url: getImgUrl('publicMobile/license/ylqx.png'),
    showType: 2,
  },
  {
    title: '高新技术企业证书',
    subTitle: '证书编号：GR202144204354',
    url: getImgUrl('publicMobile/license/2021年12月23日-高新技术企业证书.jpg'),
    showType: 2,
  },
  {
    title: '创新型中小企业',
    subTitle: '',
    url: getImgUrl('publicMobile/license/2022年12月18日-创新型中小企业.jpg'),
  },
  {
    title: '互联网药品信息服务资格证',
    subTitle: '证书编号：(粤)-经营性-2023-0491',
    url: getImgUrl('publicMobile/license/2023年10月10日-互联网药品信息服务资格证.jpg'),
    showType: 2,
  },
  {
    title: '专精特新中小企业',
    subTitle: '',
    url: getImgUrl('publicMobile/license/2023年4月10日-专精特新中小企业.jpg'),
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第8764307号',
    url: getImgUrl('publicMobile/license/CRM软著.jpg'),
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第7211897号',
    url: getImgUrl('publicMobile/license/商城软著-ios.jpg'),
    showType: 2,
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第7213901号',
    url: getImgUrl('publicMobile/license/商城软著-安卓.jpg'),
    showType: 2,
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第8764183号',
    url: getImgUrl('publicMobile/license/大数据软著.jpg'),
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第6764144号',
    url: getImgUrl('publicMobile/license/客服软著.jpg'),
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第8764053号',
    url: getImgUrl('publicMobile/license/推荐系统软著.jpg'),
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第8764145号',
    url: getImgUrl('publicMobile/license/财务软著.jpg'),
  },
  {
    title: '中华人民共和国国家版权局计算机软件著作权登记证书',
    subTitle: '证书号：软著登字第8764353号',
    url: getImgUrl('publicMobile/license/运营中心软著.jpg'),
  },
  {
    title: '药品网络交易服务第三方平台备案凭证',
    subTitle: '备案编号：（粤）网药平台备字〔2023〕0033-002号',
    url: getImgUrl('publicMobile/license/HN-ZZ20231106001药品网络交易服务第三方平台备案凭证_00.jpg'),
    showType: 2,
  },
  {
    title: '医疗器械网络交易服务第三方平台备案凭证',
    subTitle: '备案编号：(粤)网械平台备字(2023)第00043号',
    url: getImgUrl('publicMobile/license/医疗器械网络交易服务第三方平台备案变更_1730300975806_page-0001.jpg'),
    showType: 2,
  },
  {
    title: '深圳市仅销售预包装食品单位备案凭证',
    subTitle: '备案编号：YB14403060923217',
    url: getImgUrl('publicMobile/license/HN-ZZ20220111001.jpg'),
    showType: 2,
  },
  // {
  //   title: '深圳市仅销售预包装食品单位备案凭证',
  //   subTitle: '备案编号：YB14403060923217',
  //   url: getImgUrl('publicMobile/license/YG-ZZ20220110001深圳市仅销售预包装食品单位备案凭证.jpg'),
  //   showType: 2,
  // },
  {
    title: '广播电视节目制作经营许可证',
    subTitle: '许可证编号：(粤)字第02366号',
    url: getImgUrl('publicMobile/license/1712028500598.jpg'),
  },
]